import {
  CanvasModule,
  CanvasModuleType,
  PdfItemType,
} from "@pdf-tools/four-heights-pdf-web-viewer";
import { AnnotationService } from "../annotation.service";
import { imageDataUrlToUint8Array } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Tools';
import { firstValueFrom } from "rxjs";


export class CustomAddSymbolAnnotationModule extends CanvasModule {
  public toolbarElement: HTMLElement | null = null;
  private activated = false;

  static moduleInfo = {
    name: "CustomAddSymbolAnnotationModule",
    moduleType: CanvasModuleType.Tool,
    requiredFeatures: {
      annotate: true,
      fillFormFields: false,
    },
    translationKey: "Symbol",
    icon: {
      width: 16,
      height: 16,
      path: 'M5 1h1v2h1V1h1v2h1V1h1v2h1l1 1v1h2v1h-2v1h2v1h-2v1h2v1h-2v1l-1 1h-1v2H9v-2H8v2H7v-2H6v2H5v-2H4l-1-1v-1H1V9h2V8H1V7h2V6H1V5h2V4l1-1h1zM4 11h7V4H4z',
  } as any as string
    //icon: "image",
  };
  annotationService: AnnotationService | undefined;

  constructor() {
    super();
    this.toolbarElement = null;
    this.name = CustomAddSymbolAnnotationModule.moduleInfo.name;
    this.activate = this.activate.bind(this);
    this.annotationService = globalThis.__liveDokWeb__.annotationService;
  }


    public onRegister(): { toolbar: HTMLElement | undefined}  {
      this.toolbarElement = document.createElement("div");
    return {
      toolbar: this.toolbarElement ? this.toolbarElement : undefined,
    };
  }


  public async activate() {

    if(!this.annotationService) {
      return;
    }
    if (this.toolbarElement == null) {
      return;
    }

    const symbol = await firstValueFrom(this.annotationService.selectSymbol());

    if(!symbol) {
      return;
    }

    const imageInfo = {
      width: 100,
      height: 100,
      stampImage: imageDataUrlToUint8Array(symbol.imageData),
    };
    this.createImageStampAnnotation(imageInfo);


  }

  createImageStampAnnotation(imageInfo: any) {
    if (this.pdfApi !== null && this.store !== null && this.options !== null) {
      const state = this.store.getState();
      const document = state.document;
      const canvasRect = this.getCanvasSize();
      const screenCenter = {
        x: canvasRect.width / 2,
        y: canvasRect.height / 2,
      };
      // get page to insert image
      let page = this.pdfApi.getPageNumber();
      const screenRect = {
        x: 0,
        y: 0,
        w: canvasRect.width,
        h: canvasRect.height,
      };
      const pageScreenRect = this.pdfApi.getPageScreenRect(page);
      const x1 = Math.max(screenRect.x, pageScreenRect.x);
      const y1 = Math.max(screenRect.y, pageScreenRect.y);
      const x2 = Math.min(screenRect.w, pageScreenRect.x + pageScreenRect.w);
      const y2 = Math.min(screenRect.h, pageScreenRect.y + pageScreenRect.h);
      const boundingRect = {
        x: x1,
        y: y1,
        w: x2 - x1,
        h: y2 - y1,
      };
      const pageBoundingBox = this.pdfApi.transformScreenRectToPdfRect(boundingRect, page);
      const imagepPdfRect = {
        pdfX: 0,
        pdfY: 0,
        pdfW: imageInfo.width * 0.24,
        pdfH: imageInfo.height * 0.24,
        page,
      };
      if (imagepPdfRect.pdfW > pageBoundingBox.pdfW) {
        const f = (pageBoundingBox.pdfW / imagepPdfRect.pdfW) * 0.97;
        imagepPdfRect.pdfW = imagepPdfRect.pdfW * f;
        imagepPdfRect.pdfH = imagepPdfRect.pdfH * f;
      }
      if (imagepPdfRect.pdfH > pageBoundingBox.pdfH) {
        const f = (pageBoundingBox.pdfH / imagepPdfRect.pdfH) * 0.97;
        imagepPdfRect.pdfW = imagepPdfRect.pdfW * f;
        imagepPdfRect.pdfH = imagepPdfRect.pdfH * f;
      }
      imagepPdfRect.pdfX = (pageBoundingBox.pdfW - imagepPdfRect.pdfW) / 2 + pageBoundingBox.pdfX;
      imagepPdfRect.pdfY = (pageBoundingBox.pdfH - imagepPdfRect.pdfH) / 2 + pageBoundingBox.pdfY;
      this.pdfApi.registerStampImage(imageInfo.stampImage).then((imageId) => {
        if (this.pdfApi !== null && this.options !== null) {
          const annotation = {
            itemType: PdfItemType.STAMP,
            imageId,
            page,
            color: this.options.annotation.colors.defaultHighlightColor,
            pdfRect: imagepPdfRect,
            author: this.options.viewer.general.user,
          };
          this.pdfApi
            .createItem(annotation)
            .then((annot) => {
              // select new annotation
              const pdfViewerCanvasApi = this.pdfViewerCanvas;
              // @ts-ignore
              pdfViewerCanvasApi.dispatchEvent('itemSelected', annot);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    }
  }

}
